<div class="dialog">
  <div class="dialog__header clickable">
    <mat-icon (click)="onCancel()">close</mat-icon>
  </div>
  <!-- message -->
  <div [formGroup]="formGroup" class="dialog__content" mat-dialog-content>
    <div class="dialog__message" [innerHTML]="data.content"></div>
    <!-- custom input -->
      <div class="input-container">
        <mat-form-field class="input mat-datapicker" style="width: 100%;">
          <mat-label class="mb-xs">Data sugerida para término da loja</mat-label>
          <input matInput [matDatepicker]="releaseDate" formControlName="suggestedStartDate"
            (keypress)="keypressDate($event)" placeholder="DD/MM/AAAA" />
          <mat-datepicker-toggle matIconSuffix [for]="releaseDate"></mat-datepicker-toggle>
          <mat-datepicker #releaseDate></mat-datepicker>
        </mat-form-field>
      </div>
  </div>
  <!-- actions -->
  <div class="dialog__actions">
    <button mat-flat-button class="btn-default btn" [disabled]="!this.formGroup.get('suggestedStartDate')?.value" type="button" (click)="onRightButton()">
      <span>{{ data.saveButtonLabel }}</span>
    </button>
    <button class="dialog__cancel" mat-flat-button mat-dialog-close (click)="onCancel()">
      <span>{{ data.cancelButtonLabel }}</span>
    </button>
  </div>
</div>